import { ITemplates } from "../interfaces/controller";
import { TemplateLoader } from "./templateLoader";

// templates class
// hold a collection of HTML templates
export class Templates implements ITemplates {
    private templates: TemplateLoader[] = [];

    // renders a template to the screen
    // runs async, returns a jQuery promise
    public render(templateFileName: string, templateName: string, container?: JQuery): JQuery.Promise<any, any, any> {
        let template: TemplateLoader|null = null;
        let max: number;
        let i: number;

        // check if template has already been loaded
        max = this.templates.length;
        for (i = 0; i < max; i++) {
            if (this.templates[i].templateFileName === templateFileName) {
                template = this.templates[i];
                break;
            }
        }

        if (template === null) {
            // adding a new template
            template = new TemplateLoader(templateFileName);
            this.templates.push(template);
        }

        // this is the async call to load template, returns a promise
        return template.render(templateName, container);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/templates.ts